module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-1.1e5d76e8.svg";